// extracted by mini-css-extract-plugin
export default {"scoreCounter":"mQhcMmzLlG1eseO8IsfvFg=="};